const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/loop/$loopId/planner/live/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { requirePermission } from '@/common/hooks/usePermissions';
import { readLiveFlag } from '@/common/utils/readLiveFlag';
import { parseCustomFieldSearchParams } from '@/common/zod-schemas/common/filters';
import { itemFilterUrlSearchSchema } from '@/common/zod-schemas/itemFilterUrlSearchSchema';
import { itemPanelSearchSchema } from '@/features/item-panel/searchSchema';
const plannerLiveSearchSchema = itemFilterUrlSearchSchema.extend({
  ...itemPanelSearchSchema.shape
});
type PermissionContext = Parameters<ReturnType<typeof requirePermission>>[0]['context'];
type PlannerLiveBeforeLoadArgs = {
  params: {
    org: string;
    loopId: number;
  };
  context: PermissionContext & {
    flags: {
      plannerLiveEnabled: boolean;
    };
    flagOverrides: Partial<FlagKeys>;
    ldClient: LDClient | undefined;
  };
};
export const plannerLiveBeforeLoad = async (args: PlannerLiveBeforeLoadArgs) => {
  await requirePermission('edit_planner')(args);
  const plannerLiveEnabled = readLiveFlag(args.context, 'plannerLiveEnabled');
  if (!plannerLiveEnabled) {
    const {
      org,
      loopId
    } = args.params;
    throw redirect({
      to: '/org/$org/loop/$loopId/planner',
      params: {
        org,
        loopId
      }
    });
  }
};
export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/planner/live')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: (search: Record<string, unknown>) => ({
    ...plannerLiveSearchSchema.parse(search),
    ...parseCustomFieldSearchParams(search)
  }),
  beforeLoad: plannerLiveBeforeLoad
});